class StoreRegistry {
  store = null;

  register(store) {
    this.store = store;
  }

  getStore() {
    return this.store.getState();
  }
}

export const storeRegistry = new StoreRegistry();
